import axios from '../config/axiosPrivate';

type RingCentralCommunicationBackfillPayload = {
  start_date: string;
  end_date: string;
};

export const getRingCentralCommunications = async (params: any) => {
  const url = '/ringcentral/communications';
  const response = await axios.get(url, { params });
  return response.data;
};

export const getRingCentralCommunication = async (communicationId: number) => {
  const url = `/ringcentral/communications/${communicationId}`;
  const response = await axios.get(url);
  return response.data;
};

export const matchRingCentralCommunication = async (communicationId: number) => {
  const url = `/ringcentral/communications/${communicationId}/match`;
  const response = await axios.post(url);
  return response.data;
};

export const unassignRingCentralCommunication = async (communicationId: number) => {
  const url = `/ringcentral/communications/${communicationId}/unassign`;
  const response = await axios.post(url);
  return response.data;
};

export const deleteRingCentralCommunication = async (communicationId: number) => {
  const url = `/ringcentral/communications/${communicationId}`;
  const response = await axios.delete(url);
  return response.data;
};

export const initiateRingCentralCommunicationBackfill = async (payload: RingCentralCommunicationBackfillPayload) => {
  const url = '/ringcentral/communications/backfill';
  const response = await axios.post(url, payload);
  return response.data;
};
